
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/legal/colorado-safety-policy",
      function () {
        return require("private-next-pages/[lang]/legal/colorado-safety-policy/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/legal/colorado-safety-policy"])
      });
    }
  